import { render } from "./RoomDetail.vue?vue&type=template&id=2fea96da&scoped=true"
import script from "./RoomDetail.vue?vue&type=script&lang=js"
export * from "./RoomDetail.vue?vue&type=script&lang=js"

import "../assets/css/scheduleCommon.css?vue&type=style&index=0&lang=css&external"
import "./RoomDetail.vue?vue&type=style&index=1&id=2fea96da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fea96da"]])

export default __exports__